import { isBefore } from 'date-fns'

const sortCurrent = (list: Tenant[]) =>
  list.sort((a, b) => a.tenant.nomLocatairePermanent.localeCompare(b.tenant.nomLocatairePermanent))

const sortIncoming = (list: Tenant[]) =>
  list.sort((a, b) =>
    a.dates.start && b.dates.start && isBefore(new Date(a.dates.start), new Date(b.dates.start)) ? -1 : 1
  )

const sortFormer = (list: Tenant[]) =>
  list.sort((a, b) => (a.dates.end && b.dates.end && isBefore(new Date(a.dates.end), new Date(b.dates.end)) ? 1 : -1))

export const getTenantDates = (tenant: LocatairePermanentResponse): TenantDates =>
  tenant.locaux.reduce(
    (acc, cur) => {
      if (!acc.start || isBefore(new Date(cur.dateDebutOccupation), acc.start)) {
        acc = { ...acc, start: new Date(cur.dateDebutOccupation) }
      }
      if (!acc.end || isBefore(acc.end, new Date(cur.dateFinOccupation))) {
        acc = { ...acc, end: new Date(cur.dateFinOccupation) }
      }
      return acc
    },
    { start: undefined, end: undefined } as TenantDates
  )

export const getTenantStatus = (dates: TenantDates): TenantStatus | undefined => {
  if (!!dates.start && !!dates.end) {
    const now = new Date()

    const started = isBefore(new Date(dates.start), now)
    const over = isBefore(new Date(dates.end), now)

    if (started) {
      if (over) {
        return 'former'
      } else {
        return 'current'
      }
    } else {
      return 'incoming'
    }
  }
  return undefined
}

export const orderTenants = (tenants: LocatairePermanentResponse[]): OrderedTenants => {
  const ordered = tenants.reduce(
    (acc, cur) => {
      const dates = getTenantDates(cur)
      const status = getTenantStatus(dates)

      if (status) {
        acc[status].push({ tenant: cur, dates: { ...dates, status } })
      }
      return acc
    },
    {
      current: [],
      former: [],
      incoming: [],
    } as OrderedTenants
  )
  return {
    current: sortCurrent(ordered.current),
    incoming: sortIncoming(ordered.incoming),
    former: sortFormer(ordered.former),
  }
}
